import { scrollToTop } from '@helpers/scrollToTop';
import { formatPageCount } from '@helpers/utils';
import { withQueryParams } from '@hoc/withQueryParams';
import { ReactComponent as SearchIcon } from '@img/icons/search-white.svg';
import Pagination from '@stories/Components/Global/Pagination/Pagination';
import ScrollLoader from '@stories/Components/Global/ScrollLoader/ScrollLoader';
import HorizontalFormSection from '@stories/Components/HorizontalForm/HorizontalFormSection';
import * as React from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import S from './VacancyListing2.styles';
import { useApi } from '@hooks/useApi';
import VacancyCard2 from '@stories/Components/VacancyCard2/VacancyCard2';
const VacancyListing2 = ({ initialData, ...props }) => {
    const refContainer = React.useRef(null);
    const [completedInitialLoad, setCompletedInitialLoad] = React.useState(false);
    const [params, setParams] = useQueryParams({
        category: StringParam,
        pageIndex: NumberParam,
        pageSize: NumberParam,
        location: StringParam,
    });
    const category = params.category ?? '';
    const pageIndex = params.pageIndex ?? 1;
    const pageSize = params.pageSize ?? 12;
    const location = params.location ?? '';
    const [categoryRaw, setCategoryRaw] = React.useState(category);
    const [locationRaw, setlocationRaw] = React.useState(location);
    const { data, loading } = useApi(`/api/vacancies`, initialData, {
        category,
        location,
        pageIndex,
        pageSize,
    });
    React.useEffect(() => {
        // No data - skip logic //
        if (data.items.length === 0) {
            return;
        }
        // If we have some data for the first time, signal we've loaded the intial data. //
        if (data.items.length > 0 && !completedInitialLoad) {
            setCompletedInitialLoad(true);
            return;
        }
        // The initial load is done, and we've just changed the page index - scroll back to top //
        if (completedInitialLoad) {
            refContainer.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }
    }, [pageIndex, data.items]);
    return (React.createElement(S.Container, { id: props.id, flush: "top", spacing: "padding", ref: refContainer },
        React.createElement(S.Filters, { onSubmit: (event) => {
                event.preventDefault();
                setParams({ category: categoryRaw, pageIndex: 1, location: locationRaw }, 'pushIn');
            } },
            React.createElement(S.FiltersContainer, null,
                React.createElement(HorizontalFormSection, { title: "Category", inputId: "category" },
                    React.createElement(S.Select, { id: "category", name: 'category', "data-has-value": !!categoryRaw, value: categoryRaw, onChange: (e) => {
                            setCategoryRaw(e.currentTarget.value);
                        } },
                        React.createElement("option", { value: "" }, "Select a category..."),
                        data?.categoryOptions?.map((option) => (React.createElement("option", { key: option.text, value: option.value }, option.text))))),
                React.createElement(HorizontalFormSection, { title: "Location", inputId: "location" },
                    React.createElement(S.Select, { id: "location", name: 'location', "data-has-value": !!locationRaw, value: locationRaw, onChange: (e) => {
                            setlocationRaw(e.currentTarget.value);
                        } },
                        React.createElement("option", { value: "" }, "Select a location..."),
                        data?.locationOptions?.map((option) => (React.createElement("option", { key: option.text, value: option.value }, option.text))))),
                React.createElement(HorizontalFormSection, { align: "center" },
                    React.createElement(S.SearchButton, null,
                        React.createElement(SearchIcon, null),
                        " Search Vacancies")))),
        React.createElement(S.TopBar, null,
            React.createElement(S.PageCount, null, formatPageCount(pageIndex, pageSize, data.totalItems)),
            React.createElement(S.PageSize, null,
                React.createElement(S.FilterLabel, { htmlFor: "pageSize" }, "Items per page"),
                React.createElement(S.FilterSelect, { name: "pageSize", id: "pageSize", value: pageSize, onChange: (event) => {
                        setParams({ pageIndex: 1, pageSize: parseInt(event.target.value, 10) }, 'pushIn');
                    } },
                    React.createElement("option", { value: "12" }, "Show 12"),
                    React.createElement("option", { value: "24" }, "Show 24"),
                    React.createElement("option", { value: "48" }, "Show 48")))),
        React.createElement(S.ItemList, null, data.items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(VacancyCard2, { ...item }))))),
        React.createElement(S.BottomBar, null,
            React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, totalCount: data.totalItems, onPageIndexChange: (pageIndex) => {
                    setParams({ pageIndex: pageIndex }, 'pushIn');
                    scrollToTop(refContainer);
                } })),
        React.createElement(ScrollLoader, { loading: loading })));
};
export default withQueryParams(VacancyListing2);
